/* eslint-disable */
import React, { useContext } from 'react';
import Card from '../../components/card.component';
import {
  Row,
  Col,
} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { ConfigContext } from '../../context/config.context';
import SemanalGrafico from '../../components/graficos/semanal.grafico';
import * as Icons from '../../assets/iconos';
import ApplicationNews from '../../components/comunicado/applicationNews';

const Dashboard = () => {

  const history = useHistory();
  const { config } = useContext(ConfigContext);

  return (
    <>
    {config !== null ? 
    <>
      {config.dashboard.payment_pending ?
      <Row>
        <Col>
          <Card color="warning-card" className="mb-2">
            <div className="d-flex justify-content-between">
              <div style={{ paddingRight: 10, color: 'white' }}>
                  Su licencia se encuentra con pagos pendientes, debe realizar el pago para evitar el bloqueo del sistema antes del <b>{config.dashboard.expire}</b>.
                  <br/>
                  <b>AHORA PUEDES PAGAR POR WEBPAY.</b>
              </div>
              <div>
                <button onClick={ () => history.replace('/licencia')} type="button" className="btnx btnx-warn">Ver pagos</button>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      : null }

    {/*
      <ApplicationNews
        data={{
          id: 1,
          notification_code: '123ANS235',
          title: 'Tenemos una novedad',
          content: 'Contenido',
          expire: '2022-06-22',
          createAt: '2022-06-21',
        }}
      />
      */}
      <Row className="mt-3">
      <Col>
        <Card className="mb-2">
          <div className="d-flex justify-content-between">
            <div className="home-icon">
              <img src={Icons.Icono02} className="icon-nav-dashboard"/>
            </div>
            <div className="home-text">
              <h1>Clientes</h1>
              <p>{config.dashboard.clientes}</p>
            </div>
          </div>
        </Card>
      </Col>
      <Col>
        <Card className="mb-2">
          <div className="d-flex justify-content-between">
            <div className="home-icon">
             <img src={Icons.Icono06} className="icon-nav-dashboard"/>
            </div>
            <div className="home-text">
              <h1>Encomiendas</h1>
              <p>{config.dashboard.guias}</p>
            </div>
          </div>
        </Card>
      </Col>
      <Col>
        <Card className="mb-2">
          <div className="d-flex justify-content-between">
            <div className="home-icon">
              <img src={Icons.Icono13} className="icon-nav-dashboard"/>
            </div>
            <div className="home-text">
              <h1>Marítimos</h1>
              <p>{config.dashboard.maritimos}</p>
            </div>
          </div>
        </Card>
      </Col>
      <Col>
        <Card className="mb -2">
          <div className="d-flex justify-content-between">
            <div className="home-icon">
              <img src={Icons.Icono14} className="icon-nav-dashboard"/>
            </div>
            <div className="home-text">
              <h1>Aéreos</h1>
              <p>{config.dashboard.aereos}</p>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
    {config.tipo === 1 ?
    <Row className="mt-3">
        <Col>
          <Card className="pr-3">
            <SemanalGrafico data={config}/>
          </Card>
        </Col>
      </Row>
    : null}
{/*
    <Row className="mt-3">
      <Col>
        <Card>
          <div className="d-flex flex-column" style={{ height: 200 }}>
           <div className="title-card-box">Guias master</div>
           <PesoPies />
          </div>
        </Card>
      </Col>
    </Row>
*/} 
    {config.tipo === 1 ?
    <Row className="mt-3">
      <Col>
        <Card>
          <div className="d-flex justify-content-between">
            <div className="home-icon">
              <img src={Icons.Icono15} className="icon-nav-dashboard"/>
            </div>
            <div className="home-text">
              <h1>Movimientos de hoy</h1>
              <button onClick={ () => history.replace('/reportes')} type="button" className="btnx btnx-warn">Ver caja</button>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
    : null}
   </>
   : null}
   </>
  )
}

export default Dashboard;